import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=7dc20e58&scoped=true&"
import script from "./Expenses.vue?vue&type=script&lang=js&"
export * from "./Expenses.vue?vue&type=script&lang=js&"
import style0 from "./Expenses.vue?vue&type=style&index=0&id=7dc20e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc20e58",
  null
  
)

export default component.exports